module.exports = __webpack_public_path__ + "static/media/information_Partner_1.0.9558e91d.pdf";